export default "__VITE_ASSET__CC7kIzqI__"